import React, { useState } from 'react';
import './app-header.scss'

export const AppHeader = () => {
  const [ isHamburgerMenuOpen, setisHamburgerMenuOpen ] = useState(false);
  const [ isHamburgerAboutOpen, setisHamburgerAboutOpen ] = useState(false);
  const [ isHamburgerTechOpen, setisHamburgerTechOpen ] = useState(false);
  const [ isHamburgerSolutionsOpen, setisHamburgerSolutionsOpen ] = useState(false);
  const [ isHamburgerIntegrationsOpen, setisHamburgerIntegrationsOpen ] = useState(false);
  const [ isHamburgerResourcesOpen, setisHamburgerResourcesOpen ] = useState(false);
  const [ isHamburgerCompanyOpen, setisHamburgerCompanyOpen ] = useState(false);
  const [ isHamburgerLegalOpen, setisHamburgerLegalOpen ] = useState(false);
  const hamburgerMenuOpenClass = 'open';

  const toggleState = (target, target2) => {
    target2(!target);
  }

  const mobileMenuToggle = (target, target2) => {
    target2(!target);
    document.body.classList.toggle('overlay--open');
  }

  function mobileMenuDropdownToggle() {
  }

  return (
    <header class="main-header main-header--dark" id="main-header">
      <div class="main-header--logo">
        <a href="//paystand.com">
          <svg class="logo" viewBox="0 0 1000 232.9">
            <g>
              <g>
                <path class="st0" d="M100.7,3v17.6c0,2.5-1.3,4.8-3.5,6.1L27.6,67.1c-2,1.2-3.2,3.3-3.2,5.6v89.6c0,1.1,0.6,2.1,1.5,2.6l30.8,17.9
                  c0.9,0.5,1.5,1.5,1.5,2.6v19.9c0,2.3-2.5,3.8-4.5,2.6L1.5,177.5C0.6,177,0,176,0,174.9V58c0-1.1,0.6-2.1,1.5-2.6l94.7-55
                  C98.2-0.7,100.7,0.7,100.7,3z"></path>
                <path class="st0" d="M68.4,140.7l30.8,17.9c0.9,0.5,1.5,1.5,1.5,2.6v68.7c0,2.3-2.5,3.8-4.5,2.6l-18.4-10.7
                  c-0.9-0.5-1.5-1.5-1.5-2.6l0-45.4c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V82.1c0-1.1,0.6-2.1,1.5-2.6
                  l52.2-30.3c2-1.2,4.5,0.3,4.5,2.6v19.9c0,1.1-0.6,2.1-1.5,2.6L68.4,92.2c-0.9,0.5-1.5,1.5-1.5,2.6v43.3
                  C66.9,139.2,67.4,140.1,68.4,140.7z"></path>
                <path class="st1" d="M219.4,60v112.9c0,2.3-1.2,4.5-3.3,5.7l-92.9,53.9c-2,1.2-4.5-0.3-4.5-2.6v-17.6c0-2.5,1.3-4.8,3.5-6.1
                  l71.3-41.4c0.9-0.5,1.5-1.5,1.5-2.6V70.7c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V27.7c0-2.3,2.5-3.8,4.5-2.6
                  l50.5,29.3C218.2,55.5,219.4,57.7,219.4,60z"></path>
                <path class="st1" d="M176.9,82.1v66.3c0,2.5-1.3,4.8-3.5,6l-50.3,29.2c-2,1.2-4.5-0.3-4.5-2.6v-19.9c0-1.1,0.6-2.1,1.5-2.6
                  l30.8-17.9c0.9-0.5,1.5-1.5,1.5-2.6V94.8c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V3c0-2.3,2.5-3.8,4.5-2.6
                  l18.4,10.7c0.9,0.5,1.5,1.5,1.5,2.6V59c0,1.1,0.6,2.1,1.5,2.6l30.8,17.9C176.4,80.1,176.9,81.1,176.9,82.1z"></path>
              </g>
              <g>
                <path class="st2" d="M369.7,58.1c23.8,0,38.7,14.4,38.7,38c0,23.6-14.9,37.9-38.7,37.9h-25.5c-1.7,0-3,1.3-3,3v34.5
                  c0,1.7-1.3,3-3,3h-14.7c-1.7,0-3-1.3-3-3V61.1c0-1.7,1.3-3,3-3H369.7z M367.7,114.8c12,0,19-6.9,19-18.7s-7-18.8-19-18.8h-23.6
                  c-1.7,0-3,1.3-3,3v31.5c0,1.7,1.3,3,3,3H367.7z"></path>
                <path class="st2" d="M574.6,89.6c1.7,0,3,1.3,3,3v84.7c0,22.5-11.3,35.7-36.1,35.7c-16.2,0-27.7-5.2-34.1-15.7
                  c-2.3-3.6-2.7-5.8,1.1-7.6l8.2-4.4c3.9-2,4.8-1,7.3,2.4c3.4,5.6,9.2,8.4,17.2,8.4c11.6,0,17.4-5.9,17.4-17.7v-4
                  c0-1.9-1.7-3.3-3.6-2.9c-5.5,1-10.8,1.6-15.9,1.6c-22.9,0-34.3-11.8-34.3-32.9V92.6c0-1.7,1.3-3,3-3h13c1.7,0,3,1.3,3,3v46.7
                  c0,10.8,5.9,16.2,17.9,16.2c4.7,0,9.5-0.6,14.5-1.7c1.4-0.3,2.4-1.5,2.4-2.9V92.6c0-1.7,1.3-3,3-3H574.6z"></path>
                <path class="st2" d="M629.2,87.1c17.5,0,29.3,5.9,35.1,17.5c1.8,3.3,0.8,5.7-2.6,7.4l-7.4,2.9c-3.8,1.5-4.8,1.1-6.9-2.3
                  c-3.1-5.7-9-8.5-17.7-8.5c-10.3,0-15.4,2.9-15.4,8.8c0,7.2,4.9,8.9,19.2,10.2c22.3,2.1,33.4,8,33.4,26.4
                  c0,16.6-12.6,27.4-35.4,27.4c-19.2,0-31.5-6.6-36.6-19.8c-1.3-3.4-0.2-5.7,3.3-6.9l7.4-2.3c3.3-1.3,5.2-0.7,6.7,3.1
                  c2.5,6.1,8.7,9,18.5,9c11.6,0,17.4-3.3,17.4-9.7c0-7.2-5.1-9-19.7-10.5c-7.7-0.8-12.1-1.5-18.5-3.9c-3.1-1.1-5.7-2.6-7.7-4.4
                  c-3.9-3.4-6.9-9.7-6.9-18C595.5,97.3,607.1,87.1,629.2,87.1z"></path>
                <path class="st2" d="M875.7,87.1c22.9,0,34.1,11.8,34.1,32.9v51.4c0,1.7-1.3,3-3,3h-13c-1.7,0-3-1.3-3-3v-50.9
                  c0-10.7-5.9-16.1-17.9-16.1c-5.2,0-10.5,0.7-15.7,2.1c-0.8,0.3-1.1,0.8-1.1,1.6v63.2c0,1.7-1.3,3-3,3h-13c-1.7,0-3-1.3-3-3v-69.4
                  c0-5.2,1.1-7.2,6.4-9.3C852.8,88.9,863.4,87.1,875.7,87.1z"></path>
                <path class="st2" d="M927.2,121.4c0-22.3,11.5-34.3,34.3-34.3c4.3,0,9.6,0.5,16,1.5c1.8,0.3,3.5-1.1,3.5-3l0-29.5c0-1.7,1.3-3,3-3
                  h13c1.7,0,3,1.3,3,3v106.5c0,5.2-1.3,6.9-6.6,9c-9.3,3.4-19.5,5.2-30.6,5.2c-23.8,0-35.6-11-35.6-33.1V121.4z M981,109.1
                  c0-1.4-1-2.7-2.4-2.9c-5.4-1.1-9.9-1.6-13.5-1.6c-12.6,0-18.8,5.7-18.8,17.4v21.3c0,11,6.1,16.4,18.4,16.4
                  c5.7,0,10.8-0.7,15.1-1.8c0.8-0.3,1.3-1,1.3-1.8L981,109.1z"></path>
                <path class="st2" d="M712.6,107.2h17.8c1.7,0,3-1.3,3-3V92.6c0-1.7-1.3-3-3-3h-17.8c-1.7,0-3-1.3-3-3V72.9c0-1.7-1.3-3-3-3h-13
                  c-1.7,0-3,1.3-3,3v13.7c0,1.7-1.3,3-3,3h-10.2c-1.7,0-3,1.3-3,3v11.6c0,1.7,1.3,3,3,3h10.2c1.7,0,3,1.3,3,3l0,45.6
                  c0,30.2,39.4,18.3,39.4,18.3c2.7-0.9,3.5-1.9,3.4-3.4l-2.5-9.9c-1.6-5.4-1.9-6.3-4.6-5.6c-2,0.7-3.9,1.6-8.4,2.1
                  c-4.1,0.6-8.3-2.8-8.3-8.3v-38.8C709.6,108.5,710.9,107.2,712.6,107.2z"></path>
                <path class="st2" d="M451.4,87.1c23.4,0,35.1,11.3,35.1,33.8v42.5c0,5.7-1.3,7.4-5.9,9.3c-6.6,2.8-16.4,4.3-29.5,4.3
                  c-13.9,0-23.4-2.1-28.7-6.6c-5.2-4.3-7.9-11-7.9-20c0-19.5,10.5-26.4,37.2-26.4c1,0,5.2,0.3,12.6,0.7c1.7,0.1,3.2-1.3,3.2-3v-1.4
                  c0-10.7-4.6-16.2-16.4-16.2c-8,0-13.8,2.6-17.2,7.9c-2.4,3.4-3.3,3.8-6.9,2.5c-0.1,0-0.2-0.1-0.2-0.1l-7.4-3.2
                  c-3.6-1.6-3.6-3.6-1.8-6.9C423.4,92.9,434.7,87.1,451.4,87.1z M467.5,143.3c0-1.6-1.3-2.9-2.9-3c-9.6-0.4-14.5-0.7-15-0.7
                  c-11.8,0-15.7,3.4-15.7,10.7c0,7.4,3.4,11,15.4,11c7,0,12.5-0.5,16.4-1.3c1.1-0.5,1.8-1.1,1.8-2.3V143.3z"></path>
                <path class="st2" d="M783,87.1c23.4,0,35.1,11.3,35.1,33.8v42.5c0,5.7-1.3,7.4-5.9,9.3c-6.6,2.8-16.4,4.3-29.5,4.3
                  c-13.9,0-23.4-2.1-28.7-6.6c-5.2-4.3-7.9-11-7.9-20c0-19.5,10.5-26.4,37.2-26.4c1,0,5.2,0.3,12.6,0.7c1.7,0.1,3.2-1.3,3.2-3l0-1.4
                  c0-10.7-4.6-16.2-16.4-16.2c-8,0-13.8,2.6-17.2,7.9c-2.4,3.4-3.3,3.8-6.9,2.5c-0.1,0-0.2-0.1-0.2-0.1l-7.4-3.2
                  c-3.6-1.6-3.6-3.6-1.8-6.9C755,92.9,766.3,87.1,783,87.1z M799.1,143.3c0-1.6-1.3-2.9-2.9-3c-9.6-0.4-14.5-0.7-15-0.7
                  c-11.8,0-15.7,3.4-15.7,10.7c0,7.4,3.4,11,15.4,11c7,0,12.5-0.5,16.4-1.3c1.1-0.5,1.8-1.1,1.8-2.3L799.1,143.3z"></path>
              </g>
            </g>
          </svg>
        </a>
        </div>

      <nav class="main-header--primary-nav">
        <ul>
          <li>
            <span class="label">
              Why Paystand
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4">
                <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon>
              </svg>
            </span>

            <div class="dropdown">
              <div class="dropdown--intro">
                <h4>Why Paystand</h4>
                <p>Paystand is changing B2B payments with a modern infrastructure built on SaaS and blockchain that enables faster, cheaper, more secure business transactions.</p>
              </div>

              <div class="dropdown--menu-1">
                <h6>About Us</h6>

                <ul>
                  <li>
                    <a href="https://www.paystand.com/about">
                      Our Vision
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/pricing">
                      Our Pricing
                    </a>
                  </li>
                </ul>
              </div>

              <div class="dropdown--menu-2">

                <h6>Our Technology</h6>

                <ul>
                  <li>
                    <a href="https://www.paystand.com/technology/paystand-bank-network">
                      Paystand Bank Network
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/zero-card">
                      Zero Card
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/collections-automation">
                      Collections Automation
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/accept-echecks">
                      eCheck and ACH
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/blog/you-now-have-an-enterprise-blockchain">
                      Assurety
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/fund-on-file">
                      Tokenization and Fund-on-File
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/billing-payment-portal">
                      Payment Portal
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/dashboard-and-reporting">
                      Data Insights and Intelligence
                    </a>
                  </li>
                </ul>
              </div>

              <div class="dropdown--callout">
                <h5>
                  <img src="https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=317&amp;name=menu--dashboard-zoomed-1.jpg" alt="menu--dashboard-zoomed-1" width="317" srcset="https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=159&amp;name=menu--dashboard-zoomed-1.jpg 159w, https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=317&amp;name=menu--dashboard-zoomed-1.jpg 317w, https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=476&amp;name=menu--dashboard-zoomed-1.jpg 476w, https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=634&amp;name=menu--dashboard-zoomed-1.jpg 634w, https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=793&amp;name=menu--dashboard-zoomed-1.jpg 793w, https://www.paystand.com/hs-fs/hubfs/menu--dashboard-zoomed-1.jpg?width=951&amp;name=menu--dashboard-zoomed-1.jpg 951w" sizes="(max-width: 317px) 100vw, 317px" />
                </h5>

                <h5>Experience Paystand</h5>
                <p>Test drive the Paystand platform to see how easy B2B payments can be.</p>
                <p><a href="https://www.paystand.com/get-started" rel=" noopener">See Paystand In Action</a></p>
              </div>
            </div>
          </li>

          <li>
            <span class="label">
              Solutions
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
            </span>


            <div class="dropdown">

              <div class="dropdown--intro">
                <h4>Solutions</h4>
                <p>Automate accounts receivable, power your software marketplace, or connect to powerful APIs to customize your payment infrastructure.</p>
              </div>

              <div class="dropdown--menu-1">

                <h6>By Product</h6>
                <ul>
                  <li>
                    <a href="https://www.paystand.com/solutions/payments">
                      Payments
                    </a>
                  </li>

                  <li>
                    <a href="https://www.paystand.com/solutions/billing-and-receivables">
                      Billing and Receivables
                    </a>
                  </li>

                  <li>
                    <a href="https://www.paystand.com/integrations">
                      Integrations
                    </a>
                  </li>

                  <li>
                    <a href="https://www.paystand.com/solutions/software-platforms">
                      Software Platforms
                    </a>
                  </li>

                  <li>
                    <a href="https://www.paystand.com/solutions/paystand-api">
                      APIs
                    </a>
                  </li>

                  <li>
                    <a href="https://www.paystand.com/solutions/enterprise-blockchain">
                      Enterprise Blockchain
                    </a>
                  </li>
                </ul>
              </div>

              <div class="dropdown--menu-2">
                <h6>By Department</h6>
                <ul>
                  <li>
                    <a href="https://www.paystand.com/solutions/accounts-receivable">
                      Accounts Receivable
                    </a>
                  </li>
                  <li>
                    <a href="https://www.paystand.com/technology/zero-card">
                      Accounts Payable
                    </a>
                  </li>
                </ul>
              </div>

              <div class="dropdown--callout">

                <h6>BY INDUSTRY</h6>
                <ul>
                  <li><a href="https://www.paystand.com/solutions/construction" rel=" noopener">Construction</a></li>
                  <li><a href="https://www.paystand.com/solutions/food-and-beverage" rel="nofollow noopener">Food and Beverage</a></li>
                  <li><a href="https://www.paystand.com/solutions/insurance-providers" rel=" noopener">Insurance</a></li>
                  <li><a href="https://www.paystand.com/solutions/manufacturing" rel=" noopener">Manufacturing</a></li>
                  <li><a href="https://www.paystand.com/solutions/medical-suppliers" rel=" noopener">Medical Suppliers</a></li>
                  <li><a href="https://www.paystand.com/solutions/renewables-and-environment" rel=" noopener">Renewables and Environment</a></li>
                </ul>

              </div>

            </div>

          </li>

          <li>

            <span class="label">
              Integrations
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4">
                <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon>
              </svg>
            </span>

            <div class="dropdown">
              <div class="dropdown--intro">
                <h4>Integrations</h4>
                <p>Paystand integrates with major ERP and order management systems to provide robust payment functionality directly within your System of Record.</p>
              </div>

              <div class="dropdown--menu-1">

                <h6>NETSUITE</h6>
                <p>Deliver powerful payment automation inside NetSuite with the Paystand SuiteApp.</p>
                <p><a href="https://www.paystand.com/integrations/netsuite" rel=" noopener">Learn More</a></p>

                <h6>XERO</h6>
                <p>Automate your Xero-based financial process with the Paystand Xero connected app.</p>
                <p><a href="https://www.paystand.com/integrations/xero" rel=" noopener">Learn More</a></p>

              </div>

              <div class="dropdown--menu-2">

                <h6>MAGENTO</h6>
                <p>A modern payment gateway extension for eCommerce, billing, and invoicing on Magento.</p>
                <p><a href="https://www.paystand.com/integrations/magento" rel=" noopener">Learn More</a></p>

                <h6>WOOCOMMERCE</h6>
                <p>Upgrade to a unified payment platform for online checkout and invoicing.</p>
                <p><a href="https://www.paystand.com/integrations/woocommerce" rel=" noopener">Learn More</a></p>

              </div>

              <div class="dropdown--callout">
                <h5>
                  <img src="https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=450&amp;name=menu--best-practices-kit.jpg" alt="menu--best-practices-kit" width="450" srcset="https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=225&amp;name=menu--best-practices-kit.jpg 225w, https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=450&amp;name=menu--best-practices-kit.jpg 450w, https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=675&amp;name=menu--best-practices-kit.jpg 675w, https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=900&amp;name=menu--best-practices-kit.jpg 900w, https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=1125&amp;name=menu--best-practices-kit.jpg 1125w, https://www.paystand.com/hs-fs/hubfs/menu--best-practices-kit.jpg?width=1350&amp;name=menu--best-practices-kit.jpg 1350w" sizes="(max-width: 450px) 100vw, 450px"/>
                </h5>

                <h5>NetSuite Best Practices Kit</h5>
                <p>Learn the key elements for automating payments within NetSuite to streamline your payments process.</p>
                <p><a href="https://www.paystand.com/netsuite-best-practices-kit-2020" rel=" noopener">Download</a></p>

              </div>
            </div>

          </li>

          <li>
            <span class="label">
              Resources
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4">
                <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon>
              </svg>
            </span>

            <div class="dropdown">
              <div class="dropdown--intro">
                <h4>Resources</h4>
                <p>Find information about payment automation, industry best practices, customer stories, our software, our services, and many other topics.</p>
              </div>

              <div class="dropdown--menu-1">
                <h6>BLOG</h6>
                <p>Read our blog to stay up-to-date on industry news and technology announcements.</p>
                <p><a href="https://www.paystand.com/blog" rel=" noopener">Read The Blog</a></p>

                <h6>CASE STUDIES</h6>
                <p>Paystand drives success across industries and use cases.</p>
                <p><a href="https://www.paystand.com/resources/case-studies" rel=" noopener">Read Case Studies</a></p>

                <h6>WEBINARS</h6>
                <p>Register for upcoming webinars or watch our on-demand webinar library.</p>
                <p><a href="https://www.paystand.com/resources/webinars" rel=" noopener">View Webinars</a></p>
              </div>

              <div class="dropdown--menu-2">
                <h6>DATASHEETS</h6>
                <p>Browse datasheets on our software platform and key features.</p>
                <p><a href="https://www.paystand.com/resources/datasheets" rel=" noopener">Download Datasheets</a></p>

                <h6>EBOOKS</h6>
                <p>Read our in-depth guides for CFOs, Controllers, Finance teams, and start-ups.</p>
                <p><a href="https://www.paystand.com/resources/whitepapers" rel=" noopener">Browse eBooks</a></p>

                <h6>SUPPORT</h6>
                <p>Browse our Knowledge Base or contact Support <a href="mailto:support@paystand.com" rel=" noopener">support@paystand.com</a></p>
                <p><a href="https://support.paystand.com/" rel=" noopener">Browse Support</a></p>
              </div>

              <div class="dropdown--callout">
                <h5>Subscribe to the Paystand newsletter</h5>
                <p>Our monthly newsletter delivers industry insights, new product features, and key updates.</p>
              </div>
            </div>

          </li>

          <li>
            <span class="label">
              Company
              <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4">
                <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon>
              </svg>
            </span>


            <div class="dropdown">
              <div class="dropdown--intro">
                <h4>Company</h4>
                <p>Paystand is on a mission to reboot commercial finance and create a more open financial system, starting with B2B payments.</p>
              </div>

              <div class="dropdown--menu-1">

                <h6>ABOUT</h6>
                <p>We're creating a more open financial system. Learn more about the Paystand mission.</p>
                <p><a href="https://www.paystand.com/about" rel=" noopener">Learn About Our Mission</a></p>

                <h6>CAREERS</h6>
                <p>Join our fast-growing team of disruptors and visionaries.</p>
                <p><a href="https://www.paystand.com/careers" rel=" noopener">Grow With Paystand</a></p>

              </div>


              <div class="dropdown--menu-2">

                <h6>PRESS</h6>
                <p>Read about Paystand business updates and technology announcements.</p>
                <p><a href="https://www.paystand.com/press" rel=" noopener">Read About Paystand</a></p>

                <h6>CONTACT</h6>
                <p>Talk to the Paystand team today.<br/><a href="mailto:sales@paystand.com">sales@paystand.com</a> | (800) 708-6413</p>
                <p><a href="https://www.paystand.com/contact" rel=" noopener">Contact Us</a></p>

              </div>

              <div class="dropdown--callout">
                <h5>Our Offices</h5>
                <h6>HQ | Scotts Valley</h6>
                <p><img src="https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=73&amp;name=scotts-valley-navy.png" alt="scotts-valley-navy" width="73" srcset="https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=37&amp;name=scotts-valley-navy.png 37w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=73&amp;name=scotts-valley-navy.png 73w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=110&amp;name=scotts-valley-navy.png 110w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=146&amp;name=scotts-valley-navy.png 146w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=183&amp;name=scotts-valley-navy.png 183w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/scotts-valley-navy.png?width=219&amp;name=scotts-valley-navy.png 219w" sizes="(max-width: 73px) 100vw, 73px" />1800 Green Hills Road<br/>Suite 200<br/>Scotts Valley, CA 95066</p>

                <h6>GUADALAJARA</h6>
                <p><img src="https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=73&amp;name=guadalajara-navy.png" alt="guadalajara-navy" width="73" srcset="https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=37&amp;name=guadalajara-navy.png 37w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=73&amp;name=guadalajara-navy.png 73w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=110&amp;name=guadalajara-navy.png 110w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=146&amp;name=guadalajara-navy.png 146w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=183&amp;name=guadalajara-navy.png 183w, https://www.paystand.com/hs-fs/hubfs/10-Website%20(LedgerUI)/Icons/Resources%20icons/guadalajara-navy.png?width=219&amp;name=guadalajara-navy.png 219w" sizes="(max-width: 73px) 100vw, 73px" />Av. Miguel Hidalgo y Costilla<br/>1995 Arcos Vallarta<br/>44600 Guadalajara, Jalisco<br/>México</p>
              </div>
            </div>
          </li>
        </ul>
      </nav>

      <nav class="main-header--secondary-nav">

        <a href="https://www.paystand.com/contact" class="btn-white-normal">Contact</a>
        <ul>
          <li>
            <a class="label secondary_nav__login" href="https://dashboard.paystand.com/v2/signin">
              Login
            </a>
          </li>

          <li id="hamburger-menu-trigger" className={`${isHamburgerMenuOpen ? 'open' : 'closed'}`} onClick={() => mobileMenuToggle(isHamburgerMenuOpen, setisHamburgerMenuOpen)}>
            <div class="hamburger-icon label">
              <div class="icon">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </li>
        </ul>

        <div className={`hamburger-menu ${isHamburgerMenuOpen ? 'open' : 'closed'}`} id="hamburger-dropdown">
          <ul>
            <li>
                <span className={`label ${isHamburgerAboutOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerAboutOpen, setisHamburgerAboutOpen)}>
                  About Us
                    <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
                </span>
              <ul className={`${isHamburgerAboutOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/about">
                    Our Vision
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/pricing">
                    Our Pricing
                  </a>
                </li>
              </ul>
            </li>
            <li onClick={mobileMenuDropdownToggle} >

              <span className={`label ${isHamburgerTechOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerTechOpen, setisHamburgerTechOpen)}>
                Our Technology
                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
              </span>

              <ul className={`${isHamburgerTechOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/technology/paystand-bank-network">
                    Paystand Bank Network
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/technology/zero-card">
                    Zero Card
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/technology/collections-automation">
                    Collections Automation
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/accept-echecks">
                    eCheck and ACH
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/accept-credit-cards">
                    Credit and Debit Cards
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/blog/you-now-have-an-enterprise-blockchain">
                    Assurety
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/technology/fund-on-file">
                    Tokenization and Fund on File
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/technology/dashboard-and-reporting">
                    Data Insights and Intelligence
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <span className={`label ${isHamburgerSolutionsOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerSolutionsOpen, setisHamburgerSolutionsOpen)}>
                Solutions
                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
              </span>

              <ul className={`${isHamburgerSolutionsOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/solutions/accounts-receivable">
                    Accounts Receivable
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/technology/zero-card">
                    Accounts Payable
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/solutions/payments">
                    Payments
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/solutions/billing-and-receivables">
                    Billing and Receivables
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/integrations">
                    Integrations
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/solutions/software-platforms">
                    Software Platforms
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/solutions/paystand-api">
                    APIs
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/solutions/enterprise-blockchain">
                    Enterprise Blockchain
                  </a>
                </li>
              </ul>
            </li>

            <li>
                <span className={`label ${isHamburgerIntegrationsOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerIntegrationsOpen, setisHamburgerIntegrationsOpen)}>
                  Integrations
                  <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
                </span>
              <ul className={`${isHamburgerIntegrationsOpen ? 'open' : 'closed'}`}>

                <li>
                  <a href="https://www.paystand.com/integrations/netsuite">
                    NetSuite
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/integrations/xero">
                    Xero
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/integrations/magento">
                    Magento
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/integrations/woocommerce">
                    WooCommerce
                  </a>
                </li>
              </ul>
            </li>

            <li>
                <span className={`label ${isHamburgerResourcesOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerResourcesOpen, setisHamburgerResourcesOpen)}>
                  Resources
                  <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
                </span>

              <ul className={`${isHamburgerResourcesOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/blog">
                    Blog
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/resources/case-studies">
                    Case Studies
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/resources/datasheets">
                    Datasheets
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/resources/whitepapers">
                    eBooks
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/resources/webinars">
                    Webinars
                  </a>
                </li>

                <li>
                  <a href="https://support.paystand.com">
                    Support
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <span className={`label ${isHamburgerCompanyOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerCompanyOpen, setisHamburgerCompanyOpen)}>
                Company
                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
              </span>

              <ul className={`${isHamburgerCompanyOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/careers">
                    Careers
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/press">
                    Press
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/contact">
                    Contact
                  </a>
                </li>
              </ul>
            </li>

            <li>
              <span className={`label ${isHamburgerLegalOpen ? 'open' : 'closed'}`} onClick={() => toggleState(isHamburgerLegalOpen, setisHamburgerLegalOpen)}>
                Legal
                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="14px" height="8.4px" viewBox="0 0 14 8.4"> <polygon class="arrow" points="14,1.4 12.6,0 7,5.6 1.4,0 0,1.4 5.6,7 7,8.4 8.4,7"></polygon> </svg>
              </span>
              <ul className={`${isHamburgerLegalOpen ? 'open' : 'closed'}`}>
                <li>
                  <a href="https://www.paystand.com/privacy">
                    Privacy Policy
                  </a>
                </li>

                <li>
                  <a href="https://www.paystand.com/terms-of-service">
                    Terms Of Service
                  </a>
                </li>
              </ul>
            </li>

          </ul>

          <nav class="hamburger-menu--sticky-footer">
            <ul>
              <li>

                <a class="label secondary_nav__login" href="https://dashboard.paystand.com/v2/signin">
                  Login
                </a>
              </li>
              <li>
                <a href="https://www.paystand.com/contact" class="button--primary button--outline">
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </nav>
    </header>
  )
}
